import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getToken } from '../../firebase/firebaseAuth';

export const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

// This is base API, all other will need to extends from this
export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = await getToken();
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['User', 'Mission', 'GiftBonus', 'Pair'],
  endpoints: () => ({}),
});
